@if (resolved().emoji) {
  <span class="app-icon-emoji" [style.font-size.px]="size()">{{ resolved().emoji }}</span>
} @else {
  <ion-icon [name]="resolved().glyph" [style.font-size.px]="size()" [style.color]="color()" />
}
